import { UserContextService } from '../../core/service/user-context.service';
import { Component, OnInit, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { links } from 'src/app/core/links';
import { GlobalConstants } from 'src/app/core/global-constants';
import { LoginService } from 'src/app/core/service/login.service';
import { UserService } from 'src/app/core/service/user.service';
import { FormsModule } from '@angular/forms';
import { ProfileSettingsModalComponent } from '../profile-settings-modal/profile-settings-modal.component';
import { UserModel } from 'src/app/core/models/user.model';
import { NotificationComponent } from '../notification/notification.component';
import { WorkspaceService } from 'src/app/core/service/workspace.service';
import { BaseSelectorComponent } from '../../shared/form/base-selector/base-selector.component';

@Component({
    selector: 'lgfg-header-desktop',
    templateUrl: './header-desktop.component.html',
    styleUrls: ['./header-desktop.component.scss'],
    imports: [RouterLink, FormsModule, NotificationComponent, BaseSelectorComponent]
})
export class HeaderDesktopComponent implements OnInit {
    private context = inject(UserContextService);
    private loginService = inject(LoginService);
    private userService = inject(UserService);
    private workspaceService = inject(WorkspaceService);

    readonly profileSettingsModal = input<ProfileSettingsModalComponent>(undefined);

    public search: string;
    public links = links;
    public isDarkTheme = true;
    public isTechSupport: boolean;
    public hasAccessToSubmitPayment: boolean;
    public myGoalLink = links.pagesLink + '/' + links.pages.myGoal;
    public isClother = this.context.isAdmin() || this.context.isRep();

    public user: UserModel;
    public workspaces: { key: number, value: string }[] = [];
    public currentWorkspaceId: number = 1;
    // Stable single-element array for base-selector's checkedByDefault (compared by identity).
    public currentWorkspace: number[] = [];


    async ngOnInit(): Promise<void> {
        this.user = this.context.user.value;
        this.isTechSupport = this.context.isTechSupport();
        this.hasAccessToSubmitPayment = this.context.isRep() || this.context.isAdmin() || this.context.isEA() || this.context.isAccounting();
        this.isDarkTheme = this.context.user.value?.isBlackTheme != undefined ? !this.context.user.value?.isBlackTheme : false;
        this.setTheme();
        if (this.context.canSwitchWorkspace()) {
            // Inactive workspaces must not be selectable.
            const data = await this.workspaceService.getWorkspaces(true);
            this.workspaces = data.items.map(w => ({ key: w.id, value: w.name }));
            this.currentWorkspaceId = this.context.getWorkspaceId();
            this.currentWorkspace = [this.currentWorkspaceId];
        }
        this.context.avatarChange.subscribe(() => {
            this.user = this.context.user.value;
        });
    }

    public async onWorkspaceSelect(item: { key: number, value: string }): Promise<void> {
        if (!item || item.key === this.currentWorkspaceId) {
            return;
        }
        const jwt = await this.workspaceService.switchWorkspace(item.key);
        if (!jwt) return;
        sessionStorage.setItem(GlobalConstants.jwtSessionKey, jwt);
        document.cookie = GlobalConstants.jwtSessionKey + '=' + jwt;
        const user = this.context.user.value;
        user.workspaceId = item.key;
        user.workspaceName = item.value;
        this.context.setUser(user);
        window.location.reload();
    }

    public async logout(): Promise<void> {
        await this.loginService.logout();
    }

    public openHangfire() {
        document.cookie = GlobalConstants.jwtSessionKey + "=" + sessionStorage.getItem(GlobalConstants.jwtSessionKey);
        window.location.href = links.hangfireDashboard;
    }

    public async changeTheme() {
        this.setTheme();
        await this.userService.setUserTheme(this.context.user.value.id, !this.isDarkTheme);
    }

    private setTheme() {
        document.body.classList.add(!this.isDarkTheme ? 'dark-theme' : 'light-theme');
        document.body.classList.remove(!this.isDarkTheme ? 'light-theme' : 'dark-theme');
        this.context.setTheme(!this.isDarkTheme);
    }
}
